import { render, staticRenderFns } from "./SwCount.vue?vue&type=template&id=f5d5f410&scoped=true"
import script from "./SwCount.vue?vue&type=script&lang=js"
export * from "./SwCount.vue?vue&type=script&lang=js"
import style0 from "./SwCount.vue?vue&type=style&index=0&id=f5d5f410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d5f410",
  null
  
)

export default component.exports